const SUGGESTIONS_BY_ROUTE: Array<{ prefix: string; questions: string[] }> = [
  {
    prefix: '/central-ia',
    questions: [
      'Como ativar consultas aos dados da clínica na Central de suporte?',
      'Como receber paciente pelo painel e orçamento?',
      'Como falar com um humano e gerar protocolo?',
    ],
  },
  {
    prefix: '/financial/card-settlements',
    questions: [
      'O que vou receber de cartão no próximo mês?',
      'Por que o cartão não aparece em Contas a Receber?',
      'Modo repasse mensal vs imediato do cartão',
    ],
  },
  {
    prefix: '/financial/nfse',
    questions: [
      'Por que a NFSe foi rejeitada?',
      'Como reemitir uma nota com erro?',
    ],
  },
  {
    prefix: '/clinic/daily-audit',
    questions: [
      'O que significa cada pendência na auditoria diária?',
      'Quem pode marcar auditoria como OK?',
    ],
  },
  {
    prefix: '/financial/cash-register',
    questions: [
      'Por que não consigo abrir o caixa?',
      'Como fechar o caixa do dia e conferir os valores?',
      'Como lançar uma sangria ou um suprimento?',
    ],
  },
  {
    prefix: '/financial/accounts-receivable',
    questions: [
      'Como receber um paciente pelo painel e orçamento (não avulso)?',
      'Por que aparece "abra o caixa" ao receber um pagamento?',
      'Como estornar um recebimento lançado errado?',
    ],
  },
  {
    prefix: '/financial/accounts-payable',
    questions: [
      'Como lançar uma conta a pagar recorrente?',
      'Como dar baixa em uma conta já paga?',
      'Como filtrar as contas que vencem esta semana?',
    ],
  },
  {
    prefix: '/agenda',
    questions: [
      'Como receber o paciente da consulta pelo painel e orçamento?',
      'Por que um horário não aparece disponível na agenda?',
      'Como remarcar um agendamento e avisar o paciente?',
    ],
  },
  {
    prefix: '/clinic/patients',
    questions: [
      'Como receber um pagamento pelo painel do paciente e orçamento?',
      'Como cadastrar um paciente novo?',
      'Como juntar dois cadastros duplicados do mesmo paciente?',
    ],
  },
  {
    prefix: '/clinic/budgets',
    questions: [
      'Como transformar um orçamento aprovado em tratamento?',
      'Como aplicar desconto em um orçamento?',
      'Por que o orçamento está aguardando aprovação?',
    ],
  },
  {
    prefix: '/clinic/evolutions',
    questions: [
      'Como registrar uma evolução do atendimento?',
      'Como anexar arquivos a uma evolução?',
      'Por que não consigo editar uma evolução antiga?',
    ],
  },
  {
    prefix: '/inbox',
    questions: [
      'Por que as mensagens do WhatsApp não estão chegando?',
      'Como transferir uma conversa para outro atendente?',
      'Como usar as mensagens rápidas?',
    ],
  },
];

const DEFAULT_SUGGESTIONS = [
  'O que posso fazer nesta tela?',
  'Como abrir e fechar o caixa do dia?',
  'Como agendar um paciente?',
];

export function getAssistantSuggestions(pathname: string): string[] {
  const match = SUGGESTIONS_BY_ROUTE.find(
    (entry) => pathname === entry.prefix || pathname.startsWith(`${entry.prefix}/`),
  );
  return match ? match.questions : DEFAULT_SUGGESTIONS;
}
